
jQuery(document).ready(function() {
  
  // do masonry only where needed
  // test on if masonry exists (will only be included on the right pages)
    if (window.Masonry) {
      var container = document.querySelector('#container');
      var msnry = new Masonry( container, {
        // options
        itemSelector: '#container li',
      columnWidth: '.grid-sizer',
      percentPosition: true,
      stagger: 30

      });

      // ajax load more?
      // move newly loaded li's into the correct ul & reload masonry
      jQuery(document).ajaxComplete( function( event, request, settings ) {

        $newItems = jQuery( "div[class^='pbd-alp-placeholder'] li" );
        if ($newItems.length) {
          $newItems.appendTo("#container ul");
          // msnry.reloadItems();
          msnry.appended( $newItems);
        }

      });
    }


  /* forms */
    var input = jQuery('.gform_body input');
    input.on('focus', function() {
        id = this.id;
        jQuery('label[for='+id+']').addClass('input-focus');
    });

    input.on('blur', function() {
      if( !jQuery(this).val()) { // if empty
        jQuery('label[for='+id+']').removeClass('input-focus');
      }
  });

  /* reveal */
  jQuery('[data-open]').on('click', function(event) {
    var url = jQuery(this).data('url');
    var showForm = localStorage.getItem("downloadFormSubmitted") !== "true";
    if(showForm) {
      var targetModal = jQuery('#downloadLightbox');
      var title = jQuery(this).text();
      var formWrapper = targetModal.find('#reveal-newsletter-form');
      var registerText = targetModal.find('#reveal-download-register');
      var thankYouText = targetModal.find('#reveal-download-thank-you');
      var form = targetModal.find('form');
      targetModal.find('#reveal-download-title').text(title);
      thankYouText.hide();
      // listen to submit event
      jQuery(document).unbind('gform_post_render');
      jQuery(document).bind('gform_post_render', function(event, id, errors) {
        if(form.attr("id") === "gform_" + id && !errors){ // this form and no errors
          localStorage.setItem("downloadFormSubmitted", "true");
          formWrapper.hide();
          registerText.hide();
          thankYouText.show();
          download(url);
        }
      });
    }else{
      download(url);
      event.stopPropagation();
    }
  });

});


